import storage from 'store2'

const ls = storage
import {
  AUTH_TOKEN,
  SOCKET_TOKEN,
  USER_INFO,
  PERMISSIONLIST,
  HAS_LOGIN,
  DEFAULT_OPENED_MENUS,
  DEFAULT_ACTIVE_MENU,
  UNREAD_NOTICE,
  MCT_LEVEL,
  LOCALE
} from "./storage-key";

export function setLsToken(token) {
  ls.set(AUTH_TOKEN, token);
}

export function getLsToken() {
  return ls.get(AUTH_TOKEN);
}

export function setLsHasLogin(flag) {
  ls.set(HAS_LOGIN, flag);
}

export function getLsHasLogin() {
  return ls.get(HAS_LOGIN);
}

export function setLsPermission(permission_list) {
  ls.set(PERMISSIONLIST, permission_list);
}

export function getLsPermission() {
  return ls.get(PERMISSIONLIST);
}

export function setLsSocketToken(token) {
  ls.set(SOCKET_TOKEN, token);
}

export function getLsSocketToken() {
  return ls.get(SOCKET_TOKEN);
}

export function setLsUserInfo(user_info) {
  ls.set(USER_INFO, user_info);
}

export function getLsUserInfo() {
  return ls.get(USER_INFO);
}

export function setLsDefaultOpenedMenus(menus) {
  ls.set(DEFAULT_OPENED_MENUS, menus);
}

export function getLsDefaultOpenedMenus() {
  return ls.get(DEFAULT_OPENED_MENUS);
}

export function setLsDefaultActiveMenu(path) {
  ls.set(DEFAULT_ACTIVE_MENU, path);
}

export function getLsDefaultActiveMenu() {
  return ls.get(DEFAULT_ACTIVE_MENU);
}

export function setLsUnreadNotice(value) {
  ls.set(UNREAD_NOTICE, value);
}

export function getLsUnreadNotice() {
  return ls.get(UNREAD_NOTICE);
}

/* 设置组织层级 */
export function setMctLevel(level) {
  return ls.set(MCT_LEVEL, level);
}

export function getMctLevel(){
  return ls.get(MCT_LEVEL);
}

export function clearLsAll() {
  // 白名单列表
  const whitelist = [LOCALE];
  // 保存白名单数据
  const preservedData = {};
  whitelist.forEach(key => {
    preservedData[key] = ls.get(key);
  });

  // 清空全部
  [
    AUTH_TOKEN,
    SOCKET_TOKEN,
    USER_INFO,
    PERMISSIONLIST,
    HAS_LOGIN,
    DEFAULT_OPENED_MENUS,
    DEFAULT_ACTIVE_MENU,
    UNREAD_NOTICE,
  ].forEach((key) => {
    ls.remove(key);
  });
  ls.clearAll();

  // 恢复白名单数据
  Object.entries(preservedData).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      ls.set(key, value);
    }
  });
}

// 退出登录
export function onGoLoginPage() {
  clearLsAll()
  window.location.reload()
}
